import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

export const TableNoDataSmallView = () => {
  const { t } = useTranslation('payments');

  return (
    <div
      css={{
        border: `1px solid ${theme.colors.neutral20}`,
        borderRadius: theme.borderRadius.medium,
        padding: theme.spacing(2),
        display: 'flex',
        justifyContent: 'center',
        marginBottom: theme.spacing(1),
        alignItems: 'center',
      }}
    >
      <Text weight='bold' css={{ margin: 0 }}>
        {t('No data to display')}
      </Text>
    </div>
  );
};
